<div class="tags-container">
    <mat-chip-set>
        <mat-chip *ngFor="let tag of tags" [disabled]="disabled" class="tag mat-elevation-z1">
            {{ tag }}
            <button matChipRemove (click)="removeTag(tag)" [disabled]="disabled">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip>
    </mat-chip-set>

    <input 
        #inputElement 
        [formControl]="tagInput" 
        [matAutocomplete]="auto" 
        matAutocompleteTrigger
        [matAutocompleteDisabled]="disabled" 
        (keyup.enter)="addTag()" 
        (keydown.enter)="$event.preventDefault();" 
        *ngIf="showInput"
        [disabled]="disabled">

    <button 
        mat-raised-button 
        [ngClass]="showInput ? 'icon-mode' : 'text-mode'" 
        (click)="toggleInput()" 
        type="button"
        [disabled]="disabled">
        {{ showInput ? '×' : 'Add Tag' }}
    </button>

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onTagSelected($event)">
        <mat-option *ngFor="let suggestion of filteredSuggestions | async" [value]="suggestion">
            {{ suggestion }}
        </mat-option>
    </mat-autocomplete>
</div>
